
<scroll-area class="work-area" ref="workArea">
  <div class="container-fluid">
    <div class="em-block">
      <div class="em-child">
        <div class="row">
          <div class="col">
            <button type="button" data-toggle="collapse" data-target="#permission_permittees" aria-expanded="true" aria-controls="permission_permittees" class="accordion-header toggle-group">
              <h2 class="h4-sub">Add Groups</h2>
            </button>
            <div class="accordion-body collapse show" id="permission_permittees">
              <search-permittees
                  :id="selectedObjectModel.idForProp('permission_permittees')"
                  sr-only-label
                  :permittees="selectedObjectModel.permissionPermitteesArray"
                  :options="permitteeOptions"
                  @create="createPermittee"
                  @remove="tryRemovePermittee"
              >
              </search-permittees>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="em-block">
      <ul class="tabs-container">
        <li v-for="tabRoute in childRoutes" class='tab' :class="{current: isCurrentTab(tabRoute.meta.displayName)}" :key="`tab-${tabRoute.meta.displayName}`">
          <button type="button" @click="pushRoute({name: tabRoute.name})">
            {{ tabRoute.meta.displayName }}
          </button>
        </li>
      </ul>
      <div class="em-child">
        <div class="row mt-2">
          <div class="col-6">
            <h2 class="h4-sub mb-0">Grant Permissions for {{ tabName }}</h2>
          </div>
          <div class="col-6">
            <permission-permittee-filter :class="`float-right`"></permission-permittee-filter>
          </div>
          <div class="col"><hr></div>
        </div>
        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <workarea-table @remove-permittee="tryRemovePermittee">
                <template #table-rows>
                  <router-view></router-view>
                </template>
              </workarea-table>
            </div>
          </div>
        </div>
        <row v-if="selectedObjectModel.permissionPermitteesArray.length === 0">
          <p class="alert blue text-blue">To start granting permissions for {{ tabName }}, please search and add groups/users above</p>
        </row>
      </div>
    </div>
  </div>

  <confirm-delete-modal
      :state="modalStateFor(vueModalID.removeObjectModelPermissionPermittee)"
      @confirm="confirmRemovePermittee"
      @toggle-modal="resetRemovePermittee"
  >
    <template #body-text>
      <p>Removing this group or user from permission settings will disable all their current permissions across views of this object model. Are you sure you want to proceed?</p>
    </template>
  </confirm-delete-modal>
</scroll-area>
